import { Component, EventEmitter, Inject, Injector, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IDto } from '@interfaces/dto';
import { IEntity } from '@interfaces/entity';
import { EntityService } from '@services/entity/entity.service';
import { FormService } from '@services/form/form.service';
import { DtoService } from '@services/dto/dto.service';
import { RouteDataService } from '@services/route-data/route-data.service';
import { MessageService } from '@services/message/message.service';
import { ComponentBase } from '@abstracts/component-base';

@Component({
  selector: 'app-edit-entity',
  template: ''
})
export abstract class AbstractEditEntityComponent extends ComponentBase implements OnInit {

  public primaryKey: string | number;
  private valuesAtInit;

  public abstract entity: IEntity;

  @Output() entityLoadedEvent = new EventEmitter<IEntity>();

  @Inject(FormService)
  public formService: FormService;

  @Inject(MessageService)
  public messageService: MessageService;

  @Inject(DtoService)
  public dtoService: DtoService;

  @Inject(RouteDataService)
  public routeDataService: RouteDataService;

  @Inject(Router)
  public router: Router;

  @Inject(ActivatedRoute)
  public activatedRoute: ActivatedRoute;


  constructor(private entityService: EntityService, injector: Injector) {
    super(injector);
    this.formService = injector.get(FormService);
    this.messageService = injector.get(MessageService);
    this.dtoService = injector.get(DtoService);
    this.router = injector.get(Router);
    this.activatedRoute = injector.get(ActivatedRoute);
    this.routeDataService = injector.get(RouteDataService);
  }

  abstract createForm();
  abstract onSubmit(formValue);
  abstract initializeEntity(entity);
  afterInit() { }
  getAdditionalEntities() { }

  ngOnInit() {
    super.ngOnInit();

    this.primaryKey = this.activatedRoute.snapshot.params.key;

    if (!this.primaryKey) {
      this.primaryKey = this.routeDataService?.params?.key;
    }

    this.loadEntity();
    this.getAdditionalEntities();
  }

  public loadEntity() {
    this.entityService.getEntity(this.primaryKey).subscribe(result => {
      this.initializeEntity(result);
      this.initializeForm();
      this.entityLoadedEvent.emit(this.entity);
      this.afterInit();
    }, error => {});
  }

  public initializeForm() {
    this.createForm();
    this.valuesAtInit = this.formService.form?.getRawValue();
  }

  updateEntity(entity) {
    this.entityService.updateEntity(entity).subscribe(data => {
      this.ngOnInit();
    }, error => {});
  }

  updateWithDto(dto: IDto, id: string | number) {
    this.dtoService.update(this.entityService.entityRoute, dto, id).subscribe(data => {
      this.ngOnInit();
    }, error => {});
  }
}
